import studentHealth from '@/api/student-health'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  healthCategories: [],
  programs: [],
  hospitalProfiles: []
}

export const getters = {
  getTermByYearGetter: state => ac_year_id => {
    return state.programs.filter(p => p.ac_year_id == ac_year_id)
  },

  getSubProgramByTermGetter: state => ac_term_id => {
    return state.programs.filter(p => p.ac_term_id == ac_term_id)
  },

  getGradeBySubProgramGetter: state => acps_id => {
    return state.programs.filter(p => p.acps_id == acps_id)
  },
  productNotIncludeSelected:
    state =>
    ({ addedProducts, excludeProductId } = {}) => {
      if (addedProducts !== undefined && excludeProductId !== undefined) {
        return state.hospitalProfiles.filter(
          p =>
            !_.includes(
              addedProducts
                .filter(t => t.hospital_name != excludeProductId)
                .map(t => t.hospital_name),
              p.hospital_name
            )
        )
      }

      return state.hospitalProfiles
    }
}

export const mutations = {
  ...baseMutations,
  SET_HEALTH_CATEGORIES (state, data) {
    state.healthCategories = data
  },
  SET_PROGRAMS (state, data) {
    state.programs = data
  },
  SET_HOSPITAL_PROFILES (state, data) {
    state.hospitalProfiles = data
  }
}

export const actions = {
  store (context, data) {
    return studentHealth.store(data)
  },
  async find (context, id) {
    let response = await studentHealth.find(id)
    return Promise.resolve(response)
  },
  async getProgramByStudent (context, student_id) {
    let response = await studentHealth.getProgramByStudent(student_id)
    context.commit('SET_PROGRAMS', response)
  },

  async dataBeforeCreate (context) {
    if (!context.state.healthCategories.length > 0) {
      let response = await studentHealth.healthCategory()
      context.commit('SET_HEALTH_CATEGORIES', response)
    }
  },
  async getHospitalProfile (context) {
    context.commit('SET_HOSPITAL_PROFILES', [])
    let response = await studentHealth.hospitalProfile()
    context.commit('SET_HOSPITAL_PROFILES', response)
  }
}
